// src/isMobile.ts
function isMobile() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const ua = userAgent.toLowerCase();
  const isTabletUA = /ipad|android(?=.*tablet)|tablet/i.test(ua);
  const mobileRegex = /android(?!.*tablet)|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
  const isMobileUA = mobileRegex.test(ua) && !isTabletUA;
  return isMobileUA;
}
export {
  isMobile
};
//# sourceMappingURL=index.js.map